// src/config/characterMap.ts

// 显式声明：任意字符串键 → 字符串
const characterMap: Record<string, string | string[]> = {
  "kog35rnei": ["chika", "you"],
  "kpkpcc4bq": "yoshiko",
  "kpksyfo5h": "mari",
  "kpoufr3sr": "riko",
  "kpprsbydw": "hanamaru",
  "krc7p059x": "mari",
  "krca8zqv6": "yoshiko",
  "krc0e8ihl": "chika",
  "kpqtp6igz": "riko",
  "krc8mijnf": "kanan",
  "kprqh1i81": "riko",
  "kprzyuyx8": "hanamaru",
  "kps3op6qy": "dia",
  "kpshfvuag": "you",
  "kpskteerb": "you",
  "kpt9k6wws": "chika",
  "kptjerg8n": "dia",
  "kptl37gmy": "chika",
  "krtybhbru": "yoshiko",
  "kru0mczkn": "ruby",
  "krvyyoq9e": "hanamaru",
  "krwdf27ks": "riko",
  "krwf5mlko": "mari",
  "krwghnm56": "you",
  "krwm9kgcn": "dia",
  "krwonng04": "kanan",
  "krwnd6x4c": "yoshiko",
  "krwqlkaes": "chika",
  "krwrv3kh6": "riko",
  "krwu2f85q": "mari",
  "krwv518cy": "riko",
  "krwwv7nc5": "riko",
  "krwypcqvt": "mari",
  "krwzyvyl3": "hanamaru",
  "krx1pmkeo": "riko",
  "krx38fmry": "you",
  "krx51j8ol": "ruby",
  "krx6ai8bh": "hanamaru",
  "krx7odygh": "ruby",
  "krx8vg7um": "hanamaru",
  "krxafuelc": "yoshiko",
  "krxezk0lk": "dia",
  "krxg3xoty": "you",
  "krxhjq2qp": "you",
  "krxiia1k4": "yoshiko",
  "krxkqkumy": "you",
  "krxm34i97": "hanamaru",
  "krxn56izx": "ruby",
  "krxzodeew": "mari",
  "kry9vukue": "hanamaru",
  "kryjy4adn": "kanan",
  "krykhwjvk": "yoshiko",
  "krymyq8ic": "dia",
  "kryqp1bx3": "yoshiko",
  "krysqf0mn": "yoshiko",
  "kryz6g9wf": "riko",
  "krz0cpldx": "yoshiko",
  "krz195bsf": "yoshiko",
  "krz3zg8i9": "kanan",
  "krz5m1cwn": "chika",
  "krz7iwpq4": "hanamaru",
  "krz9e8oaz": "mari",
  "krzb38ia6": "hanamaru",
  "krzg6o7gm": "dia",
  "krzhi7ney": "riko",
  "krzjc3uw3": "you",
  "krzljzt4k": "riko",
  "krzmz1ybc": "chika",
  "krzqa648o": "hanamaru",
  "krzr5m0wp": "kanan",
  "krzv5hepy": "riko",
  "krzx4b80u": "you",
  "krzy1hqpq": "you",
  "krzz7i6rn": "ruby",
  "ks01e7pey": "riko",
  "ks04829kc": "yoshiko",
  "ks07plamf": "you",
  "ks09h839a": "chika",
  "ks0f8r4p5": "ruby",
  "ks0g4oer5": "hanamaru",
  "ks0b78tgg": "mari",
  "ks0j3x7gb": "riko",
  "ks0n7r9sh": "kanan",
  "ks0px56w3": "kanan",
  "ks0ssxqz0": "kanan",
  "ks0xbqkl3": "dia",
  "ks102omz0": "mari",
  "ks13ym803": "riko",
  "ktwu48mxt": "kanan",
  "kry0ko9dw": "kanan",
  "kry5bt9b0": "ruby",
  "kry7jwvgp": "you",
  "ks1evxtra": "hanamaru",
  "ks1ihmrlr": "yoshiko",
  "ks1r56dhe": "hanamaru",
  "ks1x398io": "kanan",
  "ks1yyu043": "chika",
  "ks214902j": "riko",
  "ks278s8zl": "hanamaru",
  "ks2ae57nq": "hanamaru",
  "ks2c3tgh0": "kanan",
  "ks2emn2ug": "dia",
  "ks2gevrah": "riko",
  "ks2xn3al5": "mari",
  "ks31e0gux": "hanamaru",
  "ks345envz": "you",
  "ks3il34d3": "hanamaru",
  "mmkdjg3am": "ruby",
  "qr4znqdqg": "kanan"
};

export default characterMap;